/**
 * Player-field rules shared by the form and the CSV downloads; imports nothing, so a missing admin flag fails closed.
 */

/**
 * Fields only an admin or a superAdmin may see; listing the exception keeps future admin fields a one-line change.
 */
export const ADMIN_ONLY_PLAYER_FIELDS = ['comentario'];

/** Digits only, because a phone number arrives masked, raw or imported. */
const digitsOnly = (value) => String(value ?? '').replace(/\D/g, '');

/** Trimmed and lowercased, because an e-mail arrives in whatever case was typed. */
const normalizedEmail = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase();

/** Trimmed, and empty for anything nullish. */
const normalizedId = (value) => String(value ?? '').trim();

/**
 * Does this player reuse their own team captain's contact details? Blank values never conflict; digits compared.
 */
export const captainContactConflicts = ({ player, captain } = {}) => {
  const noConflict = { tel: false, email: false };

  if (!captain) return noConflict;

  const safePlayer = player || {};
  const captainId = normalizedId(captain.identification);
  if (captainId && captainId === normalizedId(safePlayer.identification)) {
    return noConflict;
  }

  const captainTel = digitsOnly(captain.tel);
  const captainEmail = normalizedEmail(captain.email);

  return {
    tel: !!captainTel && digitsOnly(safePlayer.tel) === captainTel,
    email: !!captainEmail && normalizedEmail(safePlayer.email) === captainEmail,
  };
};

/**
 * CSV column keys: `fullName` after `lastName`, admin-only fields last for an admin; missing flag fails closed.
 */
export const playerCsvKeys = ({ modelKeys, esAdminOsuperAdmin } = {}) => {
  const keys = Array.isArray(modelKeys) ? modelKeys : [];

  const adminOnly = keys.filter((key) =>
    ADMIN_ONLY_PLAYER_FIELDS.includes(key),
  );
  const base = keys.filter((key) => !ADMIN_ONLY_PLAYER_FIELDS.includes(key));

  const lastNameIndex = base.indexOf('lastName');
  const withFullName = [
    ...base.slice(0, lastNameIndex + 1),
    'fullName',
    ...base.slice(lastNameIndex + 1),
  ];

  return esAdminOsuperAdmin ? [...withFullName, ...adminOnly] : withFullName;
};
